<template>
  <div
    v-if="item_info.item[item]"
    class="pointer data-table-th-line"
    :class="[item_info.sort_key == column ? 'data-table-sort-active' : '', 'data-table-th-' + css]"
    @click="sortBy(column)"
    :id="'item_' + item"
  >
    <el-tooltip placement="top" :disabled="!tooltip">
      <div slot="content">
        <pre class="list-column">{{ tooltip }}</pre>
      </div>
      <span class="data-table-underline">
        <pre class="list-column">{{ title }}<font-awesome-icon :icon="['fas', 'question-circle']" v-if="tooltip" /></pre>
      </span>
    </el-tooltip>
    <font-awesome-icon
      v-if="item_info.sort_key == column"
      :icon="['fas', item_info.sort_key == column && item_info.sort_order == 'asc' ? 'arrow-up' : item_info.sort_key == column && item_info.sort_order == 'desc' ? 'arrow-down' : '']"
      style="margin-left:3px;"
    />
  </div>
</template>

<script>
export default {
  name: "listColumn",
  props: ["item", "column", "title", "css", "item_info", "unsort"],
  data() {
    return {};
  },
  computed: {
    tooltip() {
      if (this.column == "average_engagement_rate") {
        return "平均エンゲージメント率(EngagementRate)を示しています。\nいいね数とコメント数の合計をフォロワー数で割った比率です。";
      } else if (this.column == "engagementRate") {
        return "平均エンゲージメント率(EngagementRate)を示しています。\nいいね数とコメント数とシェア数の合計をフォロワー数で割った比率です。";
      } else if (this.column == "average_engagement_rate_tw") {
        return "平均エンゲージメント率(EngagementRate)を示しています。\nいいね数とコメント数とリポスト数の合計をフォロワー数で割った比率です。";
      } else if (this.column == "pr_rate") {
        return "直近90日の投稿に占めるPR投稿の比率です。\n20%を超えるとPR・広告色が強い印象を受ける可能性が高まります。";
      } else if (this.column == "viewRate") {
        return "直近90日の平均視聴率を示しています。\n直近90日の1投稿あたりの平均視聴数をチャンネル登録者数で割った比率です。";
      } else if (this.column == "playRate") {
        return "直近90日の平均視聴率を示しています。\n直近90日の平均視聴回数をフォロワー数で割った比率です。";
      } else if (this.column == "playRate_organic") {
        return "直近90日のオーガニック投稿の平均視聴率を示しています。\n直近90日の平均視聴回数(ｵｰｶﾞﾆｯｸ)をフォロワー数で割った比率です。";
      } else if (this.column == "playRate_pr") {
        return "直近90日のPR投稿の平均視聴率を示しています。\n直近90日の平均視聴回数(PR)をフォロワー数で割った比率です。";
      } else if (this.column == "average_like" || this.column == "diggCount") {
        return "直近90日の1投稿あたりの平均いいね数を示しています。";
      } else if (this.column == "average_comments" || this.column == "commentCount") {
        return "直近90日の1投稿あたりの平均コメント数を示しています。";
      } else if (this.column == "average_share" || this.column == "shareCount") {
        return "直近90日の1投稿あたりの平均シェア数を示しています。";
      } else if (this.column == "average_viewCount" || this.column == "playCount") {
        return "直近90日の1投稿あたりの平均視聴回数を示しています。";
      } else if (this.column == "playCount_organic") {
        return "直近90日のオーガニック投稿の平均視聴回数を示しています。\n直近90日間で投稿がない場合は0となります。";
      } else if (this.column == "playCount_pr") {
        return "直近90日のPR投稿の平均視聴回数を示しています。\n直近90日間で投稿がない場合は0となります。";
      } else if (this.column == "average_engagementRate") {
        return "平均エンゲージメント率(EngagementRate)を示しています。\n高評価数とコメント数の合計をチャンネル登録者数で割った比率です。";
      } else if (this.column == "frequency" || this.column == "media_frequency") {
        return "直近90日の1週間あたりの投稿頻度です。";
      } else if (this.column == "likeCount") {
        return "直近90日の1投稿あたりの平均高評価数を示しています。";
      } else if (this.column == "prRate") {
        return "直近90日の投稿に占めるPR投稿の比率です。\n20%を超えるとPR・広告色が強い印象を受ける可能性が高まります。";
      } else if (this.column == "score") {
        return "同性向け商材の広告効果/パフォーマンスを示すSCOREです。\nフォロワー数、エンゲージメント率、PR率、投稿頻度、フォロワー男女比、フォロワー増加率などの様々な要素から算出しています。";
      } else if (this.column == "num") {
        return "優先順位、SCOREなどの数値を入力できます。";
      } else if (this.column == "average_video_play_count") {
        return "直近90日のリール投稿の平均再生数を示しています。\n直近90日間でリール投稿がない場合は0となります。";
      } else if (this.column == "average_video_play_count_organic") {
        return "直近90日のオーガニックリール投稿の平均再生数を示しています。\n直近90日間でリール投稿がない場合は0となります。";
      } else if (this.column == "average_video_play_count_pr") {
        return "直近90日のPRリール投稿の平均再生数を示しています。\n直近90日間でリール投稿がない場合は0となります。";
      } else if (this.column == "average_video_play_rate") {
        return "直近90日のリール投稿の平均視聴率を示しています。\n平均リール再生数をフォロワー数で割った比率です。100%を超える場合は注目されている動画を投稿している可能性があります。";
      } else if (this.column == "average_video_play_rate_organic") {
        return "直近90日のオーガニックリール投稿の平均視聴率を示しています。\n平均リール再生数(ｵｰｶﾞﾆｯｸ)をフォロワー数で割った比率です。100%を超える場合は注目されている動画を投稿している可能性があります。";
      } else if (this.column == "average_video_play_rate_pr") {
        return "直近90日のPRリール投稿の平均視聴率を示しています。\n平均リール再生数(PR)をフォロワー数で割った比率です。100%を超える場合は注目されている動画を投稿している可能性があります。";
      } else if (this.column == "followers_growth_rate_90") {
        return "直近90日のフォロワー増加率を示しています。";
      } else {
        return "";
      }
    },
  },
  created() {},
  mounted() {},
  methods: {
    sortBy(column) {
      this.$emit("sortBy", column);
    },
  },
};
</script>
